module.exports = __webpack_public_path__ + "img/FPT11.df137ec3.svg";